import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@truecare/api-client';
import { api } from '../api';

/**
 * Phase 14a follow-up — current-user query for admin layout chrome.
 *
 * Routes check auth via `beforeLoad`; this hook is for components inside
 * the rendered tree (e.g., AdminLayout's user-email + sign-out chrome).
 * Same query key as the sign-out mutation's invalidation so sign-out
 * flips this to `null` immediately.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => unwrap(api.GET('/api/v1/auth/me')),
    retry: false,
    staleTime: 60_000,
  });
}